query GetPOInvoiceSchedules($purchaseOrderId: UUID!) {
  entityDocument(id: $purchaseOrderId) {
    _poInvoiceSchedules {
      nodes {
        isSelected
        purchaseOrderId
        scheduleId
        scheduleSequence
        scheduleDate
        scheduleNote
        scheduleAmount
        isPreviouslySelected
        invoiceNumber
      }
    }
  }
}
